import Actions from "../action";

const initialState = {
    isLoading: false,
    studence_report: undefined,
    error: false
}
const StudentReportReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.STUDENT_REPORT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.STUDENT_REPORT_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                studence_report: action.data?.response || [],
                error: false
            };
        }
        case Actions.STUDENT_REPORT_FAILURE: {
            return {
                ...state,
                isLoading: false,
                studence_report: undefined,
                error: true,
            };
        }
        case Actions.CLEAR_REPORTS: {
            return {
                ...state,
                isLoading: false,
                studence_report: [],
               
            };
        }
        default:
            return state;
    }
};
export const getStudentReports = (state) => state?.STUDENT_REPORT?.studence_report;


export default StudentReportReducer;